<template>
  <div class="relative w-full flex flex-col">
    <PreviewLockedOverlay 
      v-if="locked" 
      class="absolute top-0 left-0 right-0 z-20" 
      style="height: calc(100vh - 140px);"
      :title="`Start Tracking ${brand?.name || 'this brand'} to Unlock Hooks`"
      description="See the top performing video hooks and their ads for this brand."
      use-backdrop
    />
    <HooksFilterBar
      :class="{ 'pointer-events-none select-none': locked }"
      :filters="{ selectedDateRange }"
      :text-search="textSearch"
      :live-status="liveStatus"
      :sort="sort"
      @update:textSearch="textSearch = $event"
      @update:live-status="liveStatus = $event"
      @update:sort="sort = $event"
      @update:dateRange="selectedDateRange = $event"
      @export="onExport"
    />
    <AdvertisementHooksList
      :class="{ 'pointer-events-none select-none': locked }"
      ref="hooksList"
      :brand="brand"
      :filters="mergedFilters"
      :text-search="textSearch"
      :live-status="liveStatus"
      :sort="sort"
      :locked="locked"
      @clear-search="textSearch = ''"
    />
  </div>
</template>

<script>
import AdvertisementHooksList from '../hooks/AdvertisementHooksList.vue'
import HooksFilterBar from '../hooks/HooksFilterBar.vue'
import PreviewLockedOverlay from '../PreviewLockedOverlay.vue'
import { exportHooksCSV, copyHooksAsText } from '@/utils/hooks/hooksExport'

export default {
  name: 'HooksBrandView',
  components: {
    AdvertisementHooksList,
    HooksFilterBar,
    PreviewLockedOverlay
  },
  props: {
    brand: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      textSearch: '',
      sort: 'longest_running',
      liveStatus: ['live'],
      selectedDateRange: {
        start: null,
        end: null
      }
    }
  },
  computed: {
    locked () {
      const isSubscribed = this.brand?.is_subscribed
      return isSubscribed === undefined ? false : !isSubscribed
    },
    // Fully page-local so it never touches SpyderView's shared feed filters.
    mergedFilters () {
      return {
        selectedDateRange: this.selectedDateRange,
        activeFilters: {
          ...(this.liveStatus && { orLiveStatus: this.liveStatus })
        }
      }
    }
  },
  methods: {
    async onExport (payload) {
      const { format, scope } = payload
      const list = this.$refs.hooksList
      if (!list) return

      const groups = scope === 'pinned' ? list.pinnedGroups : list.groups

      try {
        if (format === 'csv') {
          exportHooksCSV(groups)
          this.$showAlert({ type: 'success', message: 'CSV exported' })
        } else if (format === 'text') {
          const copied = await copyHooksAsText(groups)
          if (copied) {
            this.$showAlert({ type: 'success', message: 'Copied to clipboard' })
          }
        }
      } catch (error) {
        console.error('Export error:', error)
        this.$showAlert({ type: 'error', message: 'Export failed' })
      }
    }
  }
}
</script>

<style scoped>
</style>
